const resources = [
  {
    title: 'Insights & Cybersecurity Trends',
    description:
      'Explore cybersecurity insights, industry trends, platform updates, and practical tips.',
    image: '/images/Explore_ResourcesGuides_Programs/1.png',
    cta: 'Read the Blog',
    link: 'https://www.simulationslabs.com/blogs',
  },
  {
    title: 'Step-by-Step Setup Guides',
    description: 'Get best practices for running successful simulations.',
    image: '/images/Explore_ResourcesGuides_Programs/2.png',
    cta: 'View Guides',
    link: 'https://www.simulationslabs.com/guides',
  },
  {
    title: 'Join the University Cyber Cup 2026',
    description:
      'A 3-month university program designed to enable institutions to host CTFs and deliver hands-on cyber labs for students.',
    image: '/images/Explore_ResourcesGuides_Programs/3.png',
    cta: 'Explore the Program',
    link: 'https://www.simulationslabs.com/university-cyber-cup/',
  },
];

export default function ExploreResourcesSection() {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4 text-center">
        <h1 className="text-[50px] font-medium">Explore Resources, Guides & Programs</h1>
      </div>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {resources.map((resource) => (
          <a
            key={resource.title}
            href={resource.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col overflow-hidden border border-gray-200 bg-white shadow-sm transition-all duration-200 hover:border-gray-300 hover:shadow-lg"
          >
            <div className="aspect-video overflow-hidden">
              <img
                src={resource.image}
                alt={resource.title}
                className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="mb-3 text-xl font-semibold text-gray-900 transition-colors">
                {resource.title}
              </h3>
              <p className="mb-6 text-gray-600">{resource.description}</p>
              <span className="text-lightBlue mt-auto text-sm font-semibold">
                {resource.cta} →
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
